<template>
<div>
  <el-row>
    <el-col :sm="12" :lg="6">
      <el-result icon="success" title="成功提示" subTitle="请根据提示进行操作">
        <template slot="extra">
          <el-button type="primary" size="medium" @click="BackToAdminBoard">返回</el-button>
        </template>
      </el-result>
    </el-col>
  </el-row>

  <el-card>
    <el-table
    :data="accountList"
    stripe
    style="width: 100%">
    <el-table-column prop="" label="序号" type="index" width="180"></el-table-column>
    <el-table-column prop="username" label="用户名" width="180"></el-table-column>
    <el-table-column prop="password" label="密码"></el-table-column>
    </el-table>
  </el-card>
</div>
</template>

<script>
export default {
  data() {
    return {
      accountList: this.$route.params.accountList
    }
  },
  methods: {
    BackToAdminBoard() {
      console.log('back to adminBoard')
      // console.log('accountList:', this.$route.params.accountList)
      this.$router.push('/adminBoard')
    }
  }
}
</script>
